export default "https://legacy.eskolare-development.com/images/glyphs-left.png";